import { SettingsRegular } from '@fluentui/react-icons';
import type { ModuleDef } from '#src/app/navigation/module';

export const settingsModule: ModuleDef = {
  path: 'configuracoes',
  title: 'Configurações',
  icon: SettingsRegular,
  placement: 'footer',
  pages: [
    {
      path: 'preferencias',
      title: 'Preferências',
      description: 'Tema da aplicação neste navegador.',
      icon: SettingsRegular,
      // Sem permissão: preferências são de cada pessoa, não dependem de perfil.
      load: () =>
        import('#src/modules/settings/SettingsPage').then(
          (m) => m.SettingsPage,
        ),
    },
  ],
};
